import React from 'react';

import request from 'superagent';
import tobeor from 'tobeor';
import { zipObject } from '../../../utils/lodash';

import { withStyles } from '@mui/styles';

import { Paper, Dialog, Button, TextField, DialogTitle, DialogActions, LinearProgress } from '@mui/material';

import Close from '@mui/icons-material/Close';
import Loader from '../../../common/Loader';
import ModalTransition from '../../../common/ModalTransition';
import ComponentWrapper from '../../../common/ComponentWrapper';
import TrplSelect from '../../../common/TrplControls/TrplSelect';
import TargetAudienceFormula from '../../../common/TargetAudienceFormula';

import { objectToQuerystring, contactParams } from '../../../utils';
import { channels } from '../../../constants';

import CommonStyles from '../../../common/CommonStyles';
import SendFormContactsList from './SendFormContactsList';

class BroadcasterPage extends ComponentWrapper {
  state = {
    contacts: [],
    subsInterface: 0,
    contactsLoaded: false,
    sendMsgInput: '',
    sendMsgTo: '',
    sendMsgFrom: '',
    sendMsgSubject: '',
    sendStatus: {
      linearProgressCompleted: 0,
      linearProgressStep: 0,
      success: 0,
      failed: 0,
      sending: false,
    },
    isSendCompleteModalOpened: false,
    templates: [],
    template: 'none',
    templatePids: [],
    isAllContactsChecked: true,
    subs: [],
    targetAudienceModalOpened: false,
    subValue: 'contact',
    setup: {},
    sendType: 'auto',
    isDataLoaded: false,
    formula: {
      ops: [],
      cons: [],
    },
    isSetAudienceDisabled: false,
  };

  componentDidMount() {
    this.getContacts();
    this.getFlows();
  }

  getSendMsgFrom = () => {
    const { sendType, setup } = this.state;

    return sendType === 'email'
      ? (setup.emails && setup.emails.admin) || (setup.emails && setup.emails.from) || ''
      : sendType === 'sms'
      ? (setup.twilio && setup.twilio.number) || ''
      : sendType === 'facebook'
      ? setup.facebook_mid || ''
      : sendType === 'telegram' && setup.telegram
      ? setup.telegram.botname
      : '';
  };

  updateLinearSendingProgress = () => {
    const { sendStatus } = this.state;

    if (sendStatus.linearProgressCompleted === 100) {
      sendStatus.linearProgressCompleted = 0;
    } else {
      sendStatus.linearProgressCompleted += sendStatus.linearProgressStep;
    }

    this.setState({ sendStatus });
  };

  getContacts = (formula) => {
    this.setState({ contactsLoaded: false });

    const reqParams = {
      url: `/get_contacts?meta_query=["setup", "setup_contacts_tbox"]`,
      cb: (res) => {
        this.setState({ setup: res._meta_query.setup });

        const contacts = res.talks.map(talk => zipObject(contactParams, talk));

        const t_box = res._meta_query.setup_contacts_tbox;
        let subs = Object.keys(t_box.nodes).map(concept => res._meta_query.setup_contacts_tbox.nodes[concept]);

        const subsInterface = res._meta_query.setup_contacts_tbox.interface_id || [];

        let subsData = {
          restrictions: {},
        };

        if (!formula) {
          subs.forEach((sub) => {
            let counter = 0;

            contacts.forEach((contact) => {
              if (contact.ancestors.includes(sub.id)) {
                counter++;
              }
            });

            subsData[sub.id] = {
              count: counter,
            };

            if (sub && sub.box.r) {
              Object.keys(sub.box.r).forEach(rstConcept => {
                const rsts = sub.box.r[rstConcept];
                rsts.forEach(rst => subsData.restrictions[rst.id] = rst.title)
              });
            }
          });
        }

        contacts.forEach((contact) => {
          const isDisabled =
            contact.contact_info && contact.contact_info.disabled ? contact.contact_info.disabled === 'true' : false;

          contact.isSended = false;
          contact.isNeedToSend = !isDisabled;
          contact.isDisabled = isDisabled;
          contact.error = '';
        });

        const sendMsgFrom = this.getSendMsgFrom();

        this.setState(
          {
            contacts: [...contacts],
            sendMsgFrom,
            subsInterface,
            isDataLoaded: true,
            contactsLoaded: true,
          },
          () => {
            if (!formula) {
              this.setState({
                subs,
                subsData,
              });
            }
          }
        );
      },
    };

    if (formula) {
      reqParams.data = objectToQuerystring({
        formula: JSON.stringify({
          cons: formula.cons,
          ops: formula.ops,
        }),
      });
    }

    this.postWithData(reqParams);
  };

  getFlows = () => {
    this.get({
      url: '/get_jel?type=["flow"]',
      cb: (res) => {
        const templates = res.flow || [];

        this.setState({ templates });
      },
    });
  };

  onInputChange = (key, value) => {
    this.setState({ [key]: value });
  };

  onSendTypeSelectChange = (e) => {
    this.setState({ sendType: e.target.value }, () => {
      this.setState({ sendMsgFrom: this.getSendMsgFrom() });
    });
  };

  onTemplateSelectChange = (e) => {
    const { templates, subs, subValue, subsInterface } = this.state;

    this.setState({ templatePids: [] });

    if (e.target.value === 'none') {
      this.setState({
        sendMsgInput: '',
        template: 'none',
        formula: {
          cons: [],
          ops: [],
        },
        isSetAudienceDisabled: false,
      });

      return;
    }

    let templateIndex = templates.findIndex((tmplt) => {
      return tmplt.id === e.target.value;
    });

    const templatePids = [];

    if (templateIndex !== -1) {
      let sub;

      if (subValue === 'contact') {
        sub = subs.find(sub => sub.id === subsInterface);
      } else {
        sub = subs.find(sub => sub.id === +subValue);
      };

      const template = templates[templateIndex];

      if (template.category) {
        const formula = {
          cons: [templates[templateIndex].category],
          ops: [],
        };

        this.setState({
          subValue: template.category,
          formula,
          isSetAudienceDisabled: true,
        });

        sub = subs.find((sub) => {
          return sub.id === template.category;
        });

        this.getContacts(formula);
      } else {
        this.setState({
          formula: {
            cons: [],
            ops: [],
          },
          isSetAudienceDisabled: false,
        });
      }

      if (sub) {
        template.stimuls[0].pids.forEach((tPid) => {

          const pid = {
            id: tPid,
            isDisabled: !this.getRsts(sub).find(rst => rst.id === tPid),
          };
          templatePids.push(pid);
        });
      }
    }

    this.setState({
      sendMsgInput: templates[templateIndex].stimuls[0].text,
      template: e.target.value,
      templatePids,
    });
  };

  getRsts = (category) => {
    const pidsValues = [];
    if (category && category.box.r && Object.keys(category.box.r).length) {
      Object.keys(category.box.r).forEach(rstConcept => {
        category.box.r[rstConcept].forEach(rst => pidsValues.push(rst))
      })
    };
    return pidsValues;
  };

  onSendMsgClick = () => {
    const {
      contacts,
      subValue,
      sendType,
      template,
      sendStatus,
      sendMsgFrom,
      sendMsgInput,
      templatePids,
      sendMsgSubject,
    } = this.state;

    const cont = this;

    if (!sendMsgFrom) {
      alert(`You can't send message, set your contact info in the settings`);
      return;
    }

    sendStatus.success = 0;
    sendStatus.failed = 0;

    let contactsWithContactInfo = [];

    let contactsFromFilter = contacts;

    if (subValue !== 'contact') {
      contactsFromFilter = contacts.filter(contact => contact.ancestors.includes(+subValue));
    }

    const contactsNeedToSend = contactsFromFilter.filter((contact) => contact.isNeedToSend);

    const isEmail = sendType === 'email';
    const isSms = sendType === 'sms';
    const isFb = sendType === 'facebook';
    const isTg = sendType === 'telegram';

    const contactInfoKey = isEmail ? 'EMAIL' : isSms ? 'PHONE' : isFb ? 'FACEBOOK_MID' : isTg ? 'TELEGRAM_ID' : '';

    contactsNeedToSend.forEach((contact) => {
      if (contact.contact_info[contactInfoKey]) {
        contact.isSended = false;
        contactsWithContactInfo.push(contact);
      } else {
        sendStatus.failed += 1;
      }
    });

    sendStatus.linearProgressStep = 100 / contactsWithContactInfo.length;

    const sendMsgToNextContact = (index) => {
      sendStatus.sending = true;

      const filteredTemplatePids = templatePids.filter((pid) => !pid.isDisabled);
      const pids = [];

      filteredTemplatePids.forEach((pid) => pids.push(pid.id));

      const contact = contactsWithContactInfo[index];
      const contact_id = contact.contact_info.no_auth ? '' : contact.contact_info.contact_id;

      const pidsStringified = JSON.stringify(pids);

      const sendData = isEmail
        ? {
            body: sendMsgInput,
            rest: 1,
            to: contact.contact_info[contactInfoKey],
            from: sendMsgFrom,
            subject: sendMsgSubject,
            pids: pidsStringified,
            template,
            contact_id,
          }
        : isSms || isFb || isTg
        ? {
            from: sendMsgFrom,
            body: sendMsgInput,
            to: contact.contact_info[contactInfoKey],
            pids: pidsStringified,
            contact_id,
            template,
          }
        : {};

      const sendDataStringified = objectToQuerystring(sendData);

      request
        .post(`/send${sendType}`)
        .send(sendDataStringified)
        .withCredentials()
        .then((res) => {
          const resParsed = JSON.parse(res.text);
          const { status } = resParsed;

          if (status === 'error') {
            contact.isSended = false;
            contact.error = resParsed._mes;

            if (index < contactsNeedToSend.length - 1) {
              sendMsgToNextContact(index + 1);
              this.updateLinearSendingProgress();

              return;
            }
          }

          contact.isSended = true;
          sendStatus.success += 1;

          if (index === contactsWithContactInfo.length - 1) {
            sendStatus.sending = false;
            sendStatus.linearProgressStep = 0;
            sendStatus.linearProgressCompleted = 0;

            this.setState({
              sendMsgInput: '',
              templatePids: [],
              template: 'none',
              sendMsgSubject: '',
              isSendCompleteModalOpened: true,
            });
          }

          cont.setState({ contacts: [...contacts], sendStatus });

          if (index < contactsWithContactInfo.length - 1) {
            sendMsgToNextContact(index + 1);
            this.updateLinearSendingProgress();
          }
        })
        .catch(() => {
          contact.isSended = false;
          contact.error = 'Error';

          if (index < contactsNeedToSend.length - 1) {
            sendMsgToNextContact(index + 1);
            this.updateLinearSendingProgress();
          }
        });
    };

    if (contactsWithContactInfo.length) {
      sendMsgToNextContact(0);
    } else {
      alert('You need select at least one user with contact info');
    }
  };

  onSendAutomatedMsgClick = () => {
    const { contacts, sendMsgInput, sendStatus, subValue, sendMsgSubject, templatePids, template } = this.state;

    const cont = this;

    sendStatus.success = 0;
    sendStatus.failed = 0;

    let contactsFromFilter = [];
    let contactsNeedToSend = [];

    if (subValue !== 'contact') {
      contactsFromFilter = contacts.filter((contact) => {
        return contact.ancestors.includes(+subValue);
      });

      contactsFromFilter.forEach((contact) => {
        if (contact.isNeedToSend) {
          contactsNeedToSend.push(contact);
        }
      });
    } else {
      contacts.forEach((contact) => {
        if (contact.isNeedToSend) {
          contactsNeedToSend.push(contact);
        }
      });
    }

    sendStatus.linearProgressStep = 100 / contactsNeedToSend.length;

    const sendMsgToNextContact = (index) => {
      sendStatus.sending = true;

      const filteredTemplatePids = templatePids.filter((pid) => !pid.isDisabled);
      const pids = [];

      filteredTemplatePids.forEach((pid) => pids.push(pid.id));

      const contact = contactsNeedToSend[index];

      const contact_id = contact.contact_info.no_auth ? '' : contact.contact_info.contact_id;

      const pidsStringified = JSON.stringify(pids);

      const sendData = {
        body: sendMsgInput,
        subject: sendMsgSubject,
        contact_id,
        pids: pidsStringified,
        template,
      };

      const sendDataStringified = objectToQuerystring(sendData);

      request
        .post('/broadcast')
        .send(sendDataStringified)
        .withCredentials()
        .then((res) => {
          const resParsed = JSON.parse(res.text);
          const { status } = resParsed;

          if (status === 'error') {
            contact.isSended = false;
            contact.error = resParsed._mes;

            if (index < contactsNeedToSend.length - 1) {
              sendMsgToNextContact(index + 1);
              this.updateLinearSendingProgress();

              return;
            }
          }

          contact.isSended = true;
          sendStatus.success += 1;

          if (index === contactsNeedToSend.length - 1) {
            sendStatus.sending = false;
            sendStatus.linearProgressStep = 0;
            sendStatus.linearProgressCompleted = 0;

            this.setState({
              sendMsgInput: '',
              templatePids: [],
              template: 'none',
              sendMsgSubject: '',
              isSendCompleteModalOpened: true,
            });
          }

          cont.setState({ contacts: [...contacts], sendStatus });

          if (index < contactsNeedToSend.length - 1) {
            sendMsgToNextContact(index + 1);
            this.updateLinearSendingProgress();
          }
        })
        .catch(() => {
          contact.isSended = false;
          contact.error = 'Error';

          if (index < contactsNeedToSend.length - 1) {
            sendMsgToNextContact(index + 1);
            this.updateLinearSendingProgress();
          }
        });
    };

    if (contactsNeedToSend.length) {
      sendMsgToNextContact(0);
    } else {
      alert('You need select at least one user with contact info');
    }
  };

  onContactCheckBoxChange = (index, e) => {
    const { contacts } = this.state;

    contacts[index].isNeedToSend = e.target.checked;

    this.setState({ contacts: [...contacts] });
  };

  onSelectAllContactsChange = (e) => {
    const { contacts } = this.state;

    contacts.forEach((contact) => (contact.isNeedToSend = e.target.checked));

    this.setState({
      contacts: [...contacts],
      isAllContactsChecked: e.target.checked,
    });
  };

  onRemovePidClick = (pid) => {
    const { templatePids } = this.state;

    const filteredTemplatePids = templatePids.filter((tPid) => tPid.id !== pid);

    this.setState({ templatePids: filteredTemplatePids });
  };

  onTabClick = (value) => {
    this.setState({ tab: value });
  };

  onSchedulerTimeChange = (schedulerTime) => {
    this.setState({ schedulerTime });
  };

  closeSendingCompleteModal = () => {
    this.setState({ isSendCompleteModalOpened: false });
  };

  toggleTargetAudienceModal = (targetAudienceModalOpened) => {
    this.setState({ targetAudienceModalOpened });
  };

  onSaveAudienceClick = (formula) => {
    this.setState({ formula });
    this.getContacts(formula);
    this.toggleTargetAudienceModal(false);
  };

  render() {
    const {
      contacts,
      sendMsgInput,
      sendMsgTo,
      sendStatus,
      contactsLoaded,
      templates,
      template,
      templatePids,
      isSendCompleteModalOpened,
      isAllContactsChecked,
      sendMsgSubject,
      subs,
      subValue,
      subsData,
      sendType,
      isDataLoaded,
      targetAudienceModalOpened,
      isSetAudienceDisabled,
      formula,
      subsInterface,
    } = this.state;

    const { classes } = this.props;
    const sendTypes = ['auto', ...channels];
    const isSendTypeAuto = sendType === 'auto';

    const templatesKeys = [{ title: 'none', value: 'none' }];

    templates.forEach((template) => templatesKeys.push({ title: template.title, value: template.id }));

    return (
      <div>
        <Dialog
          keepMounted
          open={isSendCompleteModalOpened}
          TransitionComponent={ModalTransition}
          onClose={this.closeSendingCompleteModal}
        >
          <DialogTitle>{'Sending completed!'}</DialogTitle>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={this.closeSendingCompleteModal}>
              Ok
            </Button>
          </DialogActions>
        </Dialog>

        {sendStatus.sending ? (
          <Paper style={{ marginBottom: '20px', padding: '20px' }}>
            <span
              style={{
                display: 'flex',
                fontSize: '15px',
                marginBottom: '20px',
              }}
            >
              Please do not close the window until sending is complete!
            </span>

            <LinearProgress variant="determinate" value={sendStatus.linearProgressCompleted} />
          </Paper>
        ) : null}

          <Paper className={classes.sendFormContainer}>
            <form method="POST" id={`send-${sendType}`} action={`/send${sendType}`} className={classes.sendMsgForm}>
              <input type="hidden" name="rest" value="1" />
              <input
                type="hidden"
                name="to"
                onChange={(e) => this.onInputChange('sendMsgTo', e.target.value)}
                value={sendMsgTo}
              />

              <textarea
                placeholder="Enter message"
                className={classes.sendMsgInput}
                disabled={sendStatus.sending}
                value={sendMsgInput}
                name="body"
                onChange={(e) => this.onInputChange('sendMsgInput', e.target.value)}
              />

              <div className={classes.selectAndSendBtnContainer}>
                <div style={{ width: '150px' }}>
                  <TrplSelect
                    margin="none"
                    title="Channel"
                    value={sendType}
                    values={sendTypes}
                    disabled={sendStatus.sending}
                    onChange={(e) => this.onSendTypeSelectChange(e)}
                  />
                </div>

                <div className={classes.alignCenter}>
                  <div style={{ width: '150px' }}>
                    <TrplSelect
                      margin="none"
                      title="Template"
                      value={template}
                      complicatedValues
                      values={templatesKeys}
                      disabled={sendStatus.sending}
                      onChange={(e) => this.onTemplateSelectChange(e)}
                    />
                  </div>

                  {templatePids ? (
                    <div className={classes.templatePidsContainer}>
                      {templatePids.map((pid, index) => (
                        <div
                          style={{
                            background: `${pid.isDisabled ? 'lightgray' : '#fff'}`,
                          }}
                          key={index}
                          className={classes.pid}
                        >
                          <span>{subsData.restrictions[pid.id]}</span>
                          <Close
                            onClick={() => this.onRemovePidClick(pid.id)}
                            className={classes.pidRemoveIcon}
                            style={{ fontSize: 14 }}
                          />
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>

                {tobeor(sendType, ['email', 'auto']) ? (
                  <TextField
                    label="Email subject"
                    onChange={(e) => this.onInputChange('sendMsgSubject', e.target.value)}
                    value={sendMsgSubject}
                    className={classes.subjectInput}
                    disabled={sendStatus.sending}
                  />
                ) : null}

                <div className={classes.alignCenter}>
                  {sendStatus.sending && <div className={classes.loader} />}

                  <Button
                    disabled={!sendMsgInput || sendStatus.sending}
                    size="small"
                    variant="contained"
                    type="button"
                    color="primary"
                    onClick={(e) => (isSendTypeAuto ? this.onSendAutomatedMsgClick(e) : this.onSendMsgClick(e))}
                    className={classes.sendMsgBtn}
                  >
                    {sendStatus.sending ? 'Sending' : 'Send'}
                  </Button>
                </div>
              </div>
            </form>
          </Paper>

          {subs.length && subsInterface &&
            <TargetAudienceFormula
              subs={subs}
              subsInterface={subsInterface}
              isOpen={targetAudienceModalOpened}
              onClose={() => this.toggleTargetAudienceModal(false)}
              onSaveClick={this.onSaveAudienceClick}
            />
          }

          <Paper>
            {subs ? (
              <div className={classes.contactsInfoRow}>
                <div className={classes.alignCenter}>
                  <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    disabled={isSetAudienceDisabled}
                    className={classes.mr10}
                    onClick={() => this.toggleTargetAudienceModal(true)}
                  >
                    Set audience
                  </Button>

                  {formula
                    ? formula.cons.map((concept, conceptIndex) => {
                        const sub = subs.find(sub => sub.id === concept);

                        if (conceptIndex === 0 && sub.title) {
                          return (
                            <span style={{ fontSize: '15px', marginRight: '5px' }} key={conceptIndex}>
                              {sub.title}{' '}
                            </span>
                          );
                        }

                        return (
                          <span style={{ fontSize: '15px', marginRight: '5px' }} key={conceptIndex}>
                            {' '}
                            {formula.ops[conceptIndex - 1]} {sub.title}
                          </span>
                        );
                      })
                    : null}
                </div>

                <div className={classes.alignCenter}>
                  <span className={`${classes.contactsInfoRowSpan} ${classes.alignCenter}`}>
                    Total: {contactsLoaded ? contacts.length : null}
                  </span>

                  {!contactsLoaded ? <Loader style={{ marginLeft: '10px' }} /> : null}
                </div>

                <span className={classes.contactsInfoRowSpan}>Sent: {sendStatus.success}</span>
                <span className={classes.contactsInfoRowSpan}>Failed (or no contact info): {sendStatus.failed}</span>
              </div>
            ) : null}

            <SendFormContactsList
              classes={classes}
              subValue={subValue}
              contacts={contacts}
              subsInterface={subsInterface}
              isAllContactsChecked={isAllContactsChecked}
              onSelectAllContactsChange={this.onSelectAllContactsChange}
              onContactCheckBoxChange={this.onContactCheckBoxChange}
            />

            {!isDataLoaded ? (
              <div className={classes.loaderContainer}>
                <Loader />
              </div>
            ) : null}
          </Paper>
      </div>
    );
  }
}

const styles = {
  sendInfo: {
    marginBottom: '20px',
    fontSize: '15px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  sendFormContainer: {
    padding: '10px',
    marginBottom: '20px',
  },
  sendMsgForm: {
    display: 'flex',
    flexDirection: 'column',
  },
  sendMsgInput: {
    background: '#fff',
    padding: '5px',
    marginBottom: '10px',
    border: '1px solid #ededed',
  },
  sendMsgBtnContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  tableCell: {
    padding: '4px',
  },
  templatePidsContainer: {
    marginLeft: '10px',
    marginTop: '17px',
    maxWidth: '40%',
  },
  pid: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '1px 4px',
    marginRight: '2px',
    fontSize: '10px',
    background: '#fff',
    color: 'black',
    borderRadius: '20px',
    maxHeight: '20px',
    marginBottom: '2px',
    border: '1px solid #ededed',
    '&:hover': {
      cursor: 'default',
    },
  },
  pidRemoveIcon: {
    color: 'red',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  loader: {
    width: '20px',
    height: '20px',
    border: '3px solid #f3f3f3',
    borderTop: '3px solid #3f51b5',
    borderRadius: '50%',
    animation: '$spin 1s linear infinite;',
  },
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
  sendMsgBtn: {
    marginLeft: '5px',
  },
  selectAndSendBtnContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  templateSelectContainer: {
    backgroundColor: '#fff',
    border: '1px solid #ededed',
  },
  templateSelect: {
    paddingLeft: '6px',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  subjectInput: {
    width: '300px',
    marginLeft: '10px',
  },
  contactsInfoRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '10px',
    paddingTop: '10px',
    paddingLeft: '19px',
    paddingRight: '34px',
  },
  contactsInfoRowSpan: {
    fontSize: '15px',
  },
  tableContact: {
    width: '20%',
  },
  tableStatus: {
    maxWidth: '150px',
  },
  alignCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  sendTo: {
    marginRight: '10px',
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px',
  },
  contactDisabled: {
    opacity: '0.5',
    background: 'rgb(244, 242, 242)',
  },
  contactErrorText: {
    color: 'red',
  },
  ...CommonStyles,
};

export default withStyles(styles)(BroadcasterPage);
